// extracted by mini-css-extract-plugin
export default {"container":"Phone_container__Bprpv","content":"Phone_content__ZoR5I","indicative":"Phone_indicative__eRhw-","phone":"Phone_phone__C1sDE","format":"Phone_format__qj5n8"};